import React from "react";
import { Row, Card } from "reactstrap";
import TabsGraphs from "./TabsGraphs";
import data from "./graphData.json";

const Graphs = ({ selectedDistrict }) => {
	let { main_heading = [] } = data["graphData"][selectedDistrict];
	return (
		<div className="mt-2">
			<Row>
				<Card style={{ border: "0px", boxShadow: "0px 0px 5px 5px #F0F0F0F0" }}>
					<div className="d-flex justify-content-around">
						{main_heading.map((elem) => {
							let { value, heading, color, isPer = false } = elem;

							return (
								<div>
									<div className={`widget-numbers text-${color}`}>
										{value.toLocaleString()}
										{isPer && <>%</>}
									</div>
									<div className="heading-number text-muted">{heading}</div>
									<div className={`card-bottom-line bg-${color}`}></div>
								</div>
							);
						})}
					</div>
				</Card>
			</Row>
			<Row className="mt-1" style={{ boxShadow: "0px 0px 5px 5px #F0F0F0F0", minHeight: "400px", height: "535px" }}>
				<TabsGraphs selectedDistrict={selectedDistrict} />
			</Row>
		</div>
	);
};

export default Graphs;
